import Scenario from "../../classes/scenarioElements/Scenario";
import { useTypedSelector } from "../../state/hooks";

/**
 * use in React function components to get an auto-updating reference to the current step
 * causes re-render when the current step changes
 *
 * @export
 * @returns the actual Step object instance of the currently loaded step
 */
export default function useCurrentStep()
{
	const currentStepId = useTypedSelector(state => state.scenarioModule.currentStepId);
	if(!currentStepId)
	{
		console.error("useCurrentStep: no currentStepId!");
	}

	return Scenario.getStep(currentStepId!)!;
}